import config from 'config/config.public';
import algolia from 'algoliasearch';

const appId = config.algolia.app[process.env.NODE_ENV] || config.algolia.app.development;

export default (name, searchKey) => {
  const client = algolia(appId, searchKey);
  return client.initIndex(name);
};
